import { Component, OnInit, Input } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'cleaners-list',
    templateUrl: '../../templates/partials/list-cleaners.html'
})

export class ListCleanersComponent implements OnInit {

    @Input() cleaners;
    constructor(private router: Router) { }

    public goDetailCleaner(id: string) {
        this.router.navigate(["/cleaners", id])
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/list-cleaners.component.ts